export const actions = {
  SET_INSTANCE: 'set_instance',
  SET_CLUSTER: 'set_cluster',
  SET_DEVICE_MAP: 'set_device_map',
  SET_INITIALIZED_POSITIONS: 'set_initialized_positions',
  SET_GEOFENCES: 'set_geofences',
  ADD_GEOFENCE: 'add_geofence',
};

const _reducerActions = {
  set_instance: (state, payload) => ({
    ...state,
    instance: payload,
  }),

  set_cluster: (state, payload) => ({
    ...state,
    cluster: {...state.cluster, ...payload},
  }),

  set_device_map: (state, payload) => ({
    ...state,
    deviceMap: payload,
  }),

  set_initialized_positions: (state, payload) => ({
    ...state,
    initializedPositions: payload,
  }),

  set_geofences: (state, payload) => ({
    ...state,
    geofences: payload,
  }),

  // Soma à lista que está no estado agora, nunca a uma cópia lida antes de uma espera. Sem lista
  // carregada não há a que somar: quem criou a cerca busca a lista inteira.
  add_geofence: (state, payload) => {
    if (!state.geofences || state.geofences.some((g) => g.id === payload.id)) return state;
    return {...state, geofences: [...state.geofences, payload]};
  },
};

export const initialState = {
  instance: null,
  deviceMap: null,
  initializedPositions: false,
  geofences: null,
};

export const reducer = (state, action) => {
  const fn = _reducerActions[action.type];

  if (fn) return fn(state, action.payload);

  console.log('[WARNING] Action without reducer:', action);
  return state;
};
